// @flow
import type {
  UserOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<UserOperation>,
})
